export default "__VITE_ASSET__G3prPovJ__"